import { createTheme, Theme } from '@mui/material/styles';

// Playful: tomato red + leaf green. Dark mode is deep aubergine instead of black so the red pops.
const palette = {
    light: {
        primary: { main: '#e63a2a', contrastText: '#ffffff' },
        secondary: { main: '#4caf50', contrastText: '#102010' },
        background: { default: '#fff4e6', paper: '#ffffff' },
        text: { primary: '#2b1a14', secondary: '#5b4339' },
        snackbar: { background: '#2b1a14', textColor: '#fff4e6' },
    },
    dark: {
        primary: { main: '#ff5a47', contrastText: '#ffffff' },
        secondary: { main: '#7bd87f', contrastText: '#102010' },
        background: { default: '#1a1022', paper: '#261833' },
        text: { primary: '#fff4e6', secondary: '#d9c7d9' },
        snackbar: { background: '#fff4e6', textColor: '#1a1022' },
    },
};

export const allowedThemes = ['light', 'dark'];

export const getTheme = (mode: 'light' | 'dark'): Theme => {
    const p = palette[mode];
    const setMeta = (name: string, content: string) => {
        let el = document.querySelector(`meta[name="${name}"]`);
        if (!el) {
            el = document.createElement('meta');
            el.setAttribute('name', name);
            document.head.appendChild(el);
        }
        el.setAttribute('content', content);
    };
    setMeta('theme-color', p.background.default);

    return createTheme({
        palette: {
            mode,
            primary: p.primary,
            secondary: p.secondary,
            background: p.background,
            text: p.text,
        },
        shape: { borderRadius: 16 },
        typography: {
            fontFamily: '"Baloo 2", Roboto, Arial, sans-serif',
            button: { fontWeight: 800, textTransform: 'none' },
            h1: { fontWeight: 800 },
        },
        components: {
            MuiCssBaseline: {
                styleOverrides: {
                    html: { width: '100%', height: '100%', overflow: 'hidden' },
                    body: {
                        width: '100%',
                        height: '100%',
                        margin: 0,
                        overflow: 'hidden',
                        backgroundColor: p.background.default,
                    },
                    // Sized to the viewport, not to <body>: the AdSense script forces `height: auto !important`
                    // on html and body, which collapsed a `height: 100%` layout to nothing.
                    '#root': {
                        width: '100%',
                        height: '100vh',
                        '@supports (height: 100dvh)': { height: '100dvh' },
                        display: 'flex',
                        flexDirection: 'column',
                    },
                },
            },
            MuiSnackbarContent: {
                styleOverrides: {
                    root: {
                        backgroundColor: p.snackbar.background,
                        color: p.snackbar.textColor,
                    },
                },
            },
            MuiButton: {
                styleOverrides: { root: { minHeight: 48, borderRadius: 999 } },
            },
            MuiIconButton: {
                styleOverrides: { root: { minWidth: 48, minHeight: 48 } },
            },
        },
    });
};

export default getTheme;
